import { Card, CardContent, CardHeader, IconButton, Tooltip, Typography } from '@mui/material'
import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import Form from './Form';

const AddBud = () => {
    const navigate = useNavigate();

    return (
        <Card>
            <CardHeader
                title={
                    <Typography variant='h5'>Input BUD</Typography>
                }
                avatar={
                    <Tooltip title="Kembali">
                        <IconButton variant="outlined" onClick={() => {
                            navigate("/admin/bud", { replace: true })
                        }} color="error"><ArrowBackIcon /></IconButton>
                    </Tooltip>
                }
            // subheader="September 14, 2016"
            />
            <CardContent>
                <Form />
            </CardContent>
        </Card>
    )
}

export default AddBud